var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUdemyFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:udemy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9986 0L5.80859 3.573V7.147L11.9976 3.573L18.1886 7.147V3.573L11.9986 0ZM5.80859 10.148V18.292C5.80859 20.142 6.39759 21.535 7.54959 22.526C8.70159 23.517 10.1756 24 11.9716 24C13.7676 24 15.2406 23.518 16.4196 22.526C17.5986 21.535 18.1876 20.087 18.1876 18.212V10.148H14.9456V17.998C14.9456 20.034 13.4366 21.053 11.9976 21.053C10.5696 21.053 9.05059 20.062 9.05059 18.026V10.148H5.80859Z",
    fill: "#D58B0E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdemyFill);
export default __webpack_public_path__ + "static/media/UdemyFill.05735c4ad9e47cd540b79216fa6d95b3.svg";
export { ForwardRef as ReactComponent };